// @ts-strict-ignore
import { AfterViewInit, Component, ElementRef, Input, OnInit, Signal, viewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProjectModel } from '@project/model/project.model';
import { ProjectStatesDef } from '@project/components/project/constants/project-states-def';
import { UserUtils } from '@user/service/user-utils';
import { MultipleQuoteRequestData } from '@project/components/request/multiple-quote-request-data';
import { ProjectValidationService } from '../../validation/service/project-validation.service';
import { ProjectDataService } from '../../../service/project-data.service';
import { ProjectRequestProcessor } from '../processor/project-request.processor';
import { ProjectModelService } from '../../../service/project-model.service';
import { ProjectComponentPresenter } from '../../project-component.presenter';
import { UserModel } from '@user/model/user.model';

@Component({
  standalone: false,
  templateUrl: './project-request-approval.component.html',
  selector: 'app-project-request-approval',
})
export class ProjectRequestApprovalComponent implements OnInit, AfterViewInit {

  private checkProjectButton: Signal<ElementRef> = viewChild('checkProjectButton');

  @Input()
  public multipleQuoteRequestData: MultipleQuoteRequestData;

  public isRequestSingleQuoteMode: boolean = true;

  constructor(
    private _bsModalRef: BsModalRef,
    private projectDataService: ProjectDataService,
    private projectModel: ProjectModel,
    private projectValidationService: ProjectValidationService,
    private projectRequestProcessor: ProjectRequestProcessor,
    private projectModelService: ProjectModelService,
    private projectComponentPresenter: ProjectComponentPresenter,
    private userModel: UserModel,
  ) { }

  public ngOnInit(): void {
    if (this.multipleQuoteRequestData != null) {
      this.isRequestSingleQuoteMode = false;
    }
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.focusOnCheckProjectButton();
    }, 0);
  }

  private focusOnCheckProjectButton(): void {
    if (this.checkProjectButton !== undefined) {
      this.checkProjectButton()?.nativeElement.focus();
    }
  }

  public close(): void {
    this._bsModalRef.hide();
  }

  public onEnter(): void {
    this.checkProject();
  }

  public checkProject(): void {
    this.close();
    document.querySelector('body').classList.toggle('aside-menu-plausi');
    document.querySelector('body').classList.remove('aside-menu-label-editor');
    if (document.querySelector('body').classList.contains('aside-menu-plausi')) {
      this.projectValidationService.notifyValidateProjectView();
    }
  }

  public approveProject(): void {
    this.close();
    this.projectComponentPresenter.openProjectRequestDialog(this.multipleQuoteRequestData);
  }

  public changeProjectState(): void {
    if (!this.isChangeProjectStateAvailable()) {
      return;
    }
    this.close();
    this.projectDataService.setFinalizationState(this.projectModel.currentProject.id, ProjectStatesDef.FINALIZATION_STATE_REQUESTED).subscribe(
      (result) => {
        this.projectModel.currentProject.finalizationState = ProjectStatesDef.FINALIZATION_STATE_REQUESTED;
        this.projectRequestProcessor.changeFinalizationStateSucceeded();
        this.projectModelService.notifyFinalizationStateChanged();
      },
      (error) => this.projectRequestProcessor.changeFinalizationStateFailed(error));
  }

  public isChangeProjectStateAvailable(): boolean {
    return UserUtils.hasFinalizeProjectsPermission(this.userModel.user);
  }
}
